import { Component, Input,  input, output } from '@angular/core';
import { Choice } from '../../ballot/backend-types';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-oval-choice',
    templateUrl: './oval-choice.component.html',
    styleUrls: ['./oval-choice.component.scss'],
    standalone: false
})
export class OvalChoiceComponent {
   choice  = input.required<Choice>()
  @Input({ required: true }) ovalOnRight?: boolean;
  selectedChoice = output<Choice>()
  hasFocus: boolean = false;
  tooltipText = $localize`Click for additional information`;
  
  constructor(
    private announcer: LiveAnnouncer
  ){  }
  
  handleCheckboxChange(): void {    
      this.announcer.announce(this.choice().description)
      this.choice().selected =  !this.choice().selected    
      this.selectedChoice.emit(this.choice())
  }

  isImage(url?: string): boolean {
    const imageEndings = ['png', 'svg', 'jpg', 'jpeg']
    if (url) {
      const ending = url.split('.').pop()
      return (ending) ? imageEndings.includes(ending) : false
    } else {
      return false
    }
  }
  clearState(): void {
      this.choice().selected = false  
  }

  onFocus() {
    this.hasFocus = true;
  }

  onBlur() {
    this.hasFocus = false;
  }

  isPdf(url?: string): boolean {
    return !!url && url.toLowerCase().endsWith('.pdf');
  }
isStringEmpty(value: string | null | undefined): boolean {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }


}
